import { Input, InputProps } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import React from "react";

type Props = InputProps & {
  strict?: boolean;
  ignoreNumbers?: boolean;
  engCharAndNumbersOnly?: boolean;
  emailCharOnly?: boolean;
};

export const FormInput = React.forwardRef<HTMLInputElement, Props>(
  (
    {
      className,
      strict,
      onChange,
      ignoreNumbers,
      engCharAndNumbersOnly,
      emailCharOnly,
      ...props
    },
    ref,
  ) => {
    function handleOnChange(e: React.ChangeEvent<HTMLInputElement>) {
      const inputValue = e.target.value;
      let outValue = inputValue;

      const sanitizedValue = inputValue.replace(/[^\p{L}\p{N}\s-]/gu, "");

      if (strict && sanitizedValue !== inputValue) {
        outValue = sanitizedValue;
      }

      if (ignoreNumbers) {
        outValue = outValue.replace(/[0-9]/g, "");
      }

      if (engCharAndNumbersOnly) {
        outValue = outValue.replace(/[^A-Za-z0-9]/g, "");
      }
      if (emailCharOnly) {
        outValue = outValue.replace(/[^A-Za-z0-9@.]/g, "");
      }

      const v = { ...e, target: { ...e.target, value: outValue } };
      onChange?.(v);
    }

    return (
      <Input
        ref={ref}
        className={cn(
          "peer h-16 w-full border-secondary/20 px-4 text-sm outline-none",
          className,
        )}
        onChange={handleOnChange}
        {...props}
      />
    );
  },
);
